import APIOpen from './entities/open';
import APIUsers from './entities/users';
import APIBusinesses from './entities/businesses';
import APIPurchases from './entities/purchase';
import APISuppliers from './entities/suppliers';
import APIAgreements from './entities/agreements';
import APIPayroll from './entities/payroll';
import APIPayments from './entities/payments';
import APIClients from './entities/client';
import APIProducts from './entities/products';
import APIAccountability from './entities/accountability';
import APICharges from './entities/charges';
import APIAdmin from './entities/admin';
import APICybersource from './entities/cybersource';

const apiMethods = {
  // Open
  registerUser: ['registerUser', APIOpen.registerUser],

  // User
  getUser: ['getUser', APIUsers.getUser],
  updateUser: ['updateUser', APIUsers.updateUser],

  //  Business
  createBusiness: ['createBusiness', APIBusinesses.createBusiness],
  getBusiness: ['getBusiness', APIBusinesses.getBusiness],
  updateBusiness: ['updateBusiness', APIBusinesses.updateBusiness],
  getDIANConnectionToken: ['getDIANConnectionToken', APIBusinesses.getDIANConnectionToken],
  updateDIANConnection: ['updateDIANConnection', APIBusinesses.updateDIANConnection],
  deleteDIANConnection: ['deleteDIANConnection', APIBusinesses.deleteDIANConnection],
  getBANKConnectAccountLink: ['getBANKConnectAccountLink', APIBusinesses.getBANKConnectAccountLink],
  deleteBANKAccounts: ['deleteBANKAccounts', APIBusinesses.deleteBANKAccounts],
  setDefaultBankAccount: ['setDefaultBankAccount', APIBusinesses.setDefaultBankAccount],
  getDruoConnections: ['getDruoConnections', APIBusinesses.getDruoConnections],
  getDIANConnection: ['getDIANConnection', APIBusinesses.getDIANConnection],
  deletePSEAccount: ['deletePSEAccount', APIBusinesses.deletePSEAccount],

  //  Purchase
  createPurchase: ['createPurchase', APIPurchases.createPurchase],
  getPurchase: ['getPurchase', APIPurchases.getPurchase],
  getPurchasesPaginated: ['getPurchasesPaginated', APIPurchases.getPurchasesPaginated],
  updatePurchase: ['updatePurchase', APIPurchases.updatePurchase],
  updatePurchases: ['updatePurchases', APIPurchases.updatePurchases],
  deletePurchases: ['deletePurchases', APIPurchases.deletePurchases],
  markPurchasesAsPayed: ['markPurchasesAsPayed', APIPurchases.markPurchasesAsPayed],
  payPurchases: ['payPurchases', APIPurchases.payPurchases],
  sendInternationalNotification: ['sendInternationalNotification', APIPurchases.sendInternationalNotification],
  getPurchasesPayoutVoucher: ['getPurchasesPayoutVoucher', APIPurchases.getPurchasesPayoutVoucher],
  getPurchasePayoutVoucher: ['getPurchasePayoutVoucher', APIPurchases.getPurchasePayoutVoucher],
  getSupplierPayoutVoucher: ['getSupplierPayoutVoucher', APIPurchases.getSupplierPayoutVoucher],
  getPurchasesByIds: ['getPurchasesByIds', APIPurchases.getPurchasesByIds],
  sendInternationalNotification: ['sendInternationalNotification', APIPurchases.sendInternationalNotification],

  // Supplier
  createSupplier: ['createSupplier', APISuppliers.createSupplier],
  getSupplier: ['getSupplier', APISuppliers.getSupplier],
  getSupplierByIdentification: ['getSupplierByIdentification', APISuppliers.getSupplierByIdentification],
  updateSupplier: ['updateSupplier', APISuppliers.updateSupplier],
  deleteSupplier: ['deleteSupplier', APISuppliers.deleteSupplier],
  getSuppliersPaginated: ['getSuppliersPaginated', APISuppliers.getSuppliersPaginated],
  getSuppliersByIds: ['getSuppliersByIds', APISuppliers.getSuppliersByIds],
  getSuppliersByStatus: ['getSuppliersByStatus', APISuppliers.getSuppliersByStatus],
  getAllSuppliers: ['getAllSuppliers', APISuppliers.getAllSuppliers],
  getSupplierPurchases: ['getSupplierPurchases', APISuppliers.getSupplierPurchases],
  getSupplierPurchasesPaginated: ['getSupplierPurchasesPaginated', APISuppliers.getSupplierPurchasesPaginated],
  deleteSupplierDruoBanksAccounts: ['deleteSupplierDruoBanksAccounts', APISuppliers.deleteSupplierDruoBanksAccounts],
  createSuppliersByFile: ['createSuppliersByFile', APISuppliers.createSuppliersByFile],
  getSuppliersBatchCreationById: ['getSuppliersBatchCreationById', APISuppliers.getSuppliersBatchCreationById],

  // Agreements
  getAgreementsCategories: ['getAgreementsCategories', APIAgreements.getAgreementsCategories],
  getMoviiAgreements: ['getMoviiAgreements', APIAgreements.getMoviiAgreements],
  getBusinessAgreements: ['getBusinessAgreements', APIAgreements.getBusinessAgreements],
  deleteBusinessAgreements: ['deleteBusinessAgreements', APIAgreements.deleteBusinessAgreements],
  payAgreements: ['payAgreements', APIAgreements.payAgreements],
  getAgreementsPayoutVoucher: ['getAgreementsPayoutVoucher', APIAgreements.getAgreementsPayoutVoucher],
  getAgreementPayoutVoucher: ['getAgreementPayoutVoucher', APIAgreements.getAgreementPayoutVoucher],

  // Payroll
  createCollaborator: ['createCollaborator', APIPayroll.createCollaborator],
  createCollaboratorsByFile: ['createCollaboratorsByFile', APIPayroll.createCollaboratorsByFile],
  getCollaborator: ['getCollaborator', APIPayroll.getCollaborator],
  updateCollaborator: ['updateCollaborator', APIPayroll.updateCollaborator],
  deleteCollaborator: ['deleteCollaborator', APIPayroll.deleteCollaborator],
  getCollaborators: ['getCollaborators', APIPayroll.getCollaborators],
  getCollaboratorsById: ['getCollaboratorsById', APIPayroll.getCollaboratorsById],
  getCollaboratorsPaginated: ['getCollaboratorsPaginated', APIPayroll.getCollaboratorsPaginated],
  payCollaborators: ['payCollaborators', APIPayroll.payCollaborators],
  getPayrollPayoutVoucher: ['getPayrollPayoutVoucher', APIPayroll.getPayrollPayoutVoucher],
  getCollaboratorPayoutVoucher: ['getCollaboratorPayoutVoucher', APIPayroll.getCollaboratorPayoutVoucher],
  deleteCollaboratorDruoBanksAccounts: ['deleteCollaboratorDruoBanksAccounts', APIPayroll.deleteCollaboratorDruoBanksAccounts],
  getCollaboratorPayoutPaginated: ['getCollaboratorPayoutPaginated', APIPayroll.getCollaboratorPayoutPaginated],
  getCollaboratorsBatchCreationById: ['getCollaboratorsBatchCreationById', APIPayroll.getCollaboratorsBatchCreationById],

  // Payments
  getPayoutsPaginated: ['getPayoutsPaginated', APIPayments.getPayoutsPaginated],
  getPayout: ['getPayout', APIPayments.getPayout],
  getPaymentAndChargesSummary: ['getPaymentAndChargesSummary', APIPayments.getPaymentAndChargesSummary],
  getPricing: ['getPricing', APIPayments.getPricing],
  getPseBanks: ['getPseBanks', APIPayments.getPseBanks],

  // Accountability
  getWorldOfficeWorksheetNotaContabilidad: [
    'getWorldOfficeWorksheetNotaContabilidad',
    APIAccountability.getWorldOfficeWorksheetNotaContabilidad
  ],
  getWorldOfficeWorksheetTercerosConDirecciones: [
    'getWorldOfficeWorksheetTercerosConDirecciones',
    APIAccountability.getWorldOfficeWorksheetTercerosConDirecciones
  ],

  //client
  createClient: ['createClient', APIClients.createClient],
  getClientsPaginated: ['getClientsPaginated', APIClients.getClientsPaginated],
  getClient: ['getClient', APIClients.getClient],
  updateClient: ['updateClient', APIClients.updateClient],
  deleteClient: ['deleteClient', APIClients.deleteClient],
  getAllClients: ['getAllClients', APIClients.getAllClients],
  uploadClients: ['uploadClients', APIClients.uploadClients],

  //Products
  createProduct: ['createProduct', APIProducts.createProduct],
  getProductsPaginated: ['getProductsPaginated', APIProducts.getProductsPaginated],
  getAllProducts: ['getAllProducts', APIProducts.getAllProducts],
  getProduct: ['getProduct', APIProducts.getProduct],
  deleteProducts: ['deleteProducts', APIProducts.deleteProducts],
  updateProducts: ['updateProducts', APIProducts.updateProducts],

  //Charges
  createCharge: ['createCharge', APICharges.createCharge],
  getChargesPaginated: ['getChargesPaginated', APICharges.getChargesPaginated],
  generateCharge: ['generateCharge', APICharges.generateCharge],
  getChargePaymentReceipt: ['getChargePaymentReceipt', APICharges.getChargePaymentReceipt],
  getChargeVoucher: ['getChargeVoucher', APICharges.getChargeVoucher],

  // Admin
  getCatalogs: ['getCatalogs', APIAdmin.getCatalogs],

  // Cybersource
  createCustomer: ['createCustomer', APICybersource.createCustomer],
  generateCaptureContext: ['generateCaptureContext', APICybersource.generateCaptureContext],
  createPayment: ['createPayment', APICybersource.createPayment]
};

export default apiMethods;
